import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.cashapp_merchant_deposit,
    (cashapp_merchant_deposit) => {
        return {
            stage: cashapp_merchant_deposit.stage
        }
    }
)